/**
 * FashionAI Configuration
 * Centralized configuration for environment variables and feature flags
 */

// API Configuration
// In production, always use the production API regardless of environment variables
// This prevents localhost URLs from being used in production builds
const isProduction = typeof window !== 'undefined' &&
  (window.location.hostname === 'fashionsai.net' ||
   window.location.hostname === 'www.fashionsai.net' ||
   window.location.hostname === 'fashionai.net' ||
   window.location.hostname === 'www.fashionai.net' ||
   window.location.hostname.endsWith('.pages.dev'));

export const API_URL = isProduction
  ? "https://fashionai-api.allan-elleuch.workers.dev/api/v1"
  : (process.env.REACT_APP_API_URL || "https://fashionai-api.allan-elleuch.workers.dev/api/v1");

// Feature Flags
export const ADVANCED_MODE = process.env.REACT_APP_ADVANCED_MODE === 'true';
export const PHONE_CASE_MOCKUP_ENABLED = process.env.REACT_APP_PHONE_CASE_MOCKUP === 'true';
export const TSHIRT_3D_VIEWER_ENABLED = process.env.REACT_APP_TSHIRT_3D_VIEWER === 'true';

// UI Modes
export const UI_MODES = {
  SIMPLE: 'simple',
  ADVANCED: 'advanced',
};

// Helper to check if feature is enabled
export const isFeatureEnabled = (featureName) => {
  switch (featureName) {
    case 'advancedMode':
      return ADVANCED_MODE;
    default:
      return false;
  }
};

// Log configuration on load
console.log('⚙️ FashionAI Configuration:');
console.log('  API URL:', API_URL);
console.log('  Advanced Mode:', ADVANCED_MODE);
console.log('  Phone Case Mockup:', PHONE_CASE_MOCKUP_ENABLED);
console.log('  T-Shirt 3D Viewer:', TSHIRT_3D_VIEWER_ENABLED);
